import * as camperContactTokens from '../themes/tokens/generated/campercontact/tokens';
import * as zandvoortTokens from '../themes/tokens/generated/zandvoort/tokens';
import * as whitelabelTokens from '../themes/tokens/generated/whitelabel/tokens';

const currentTheme = process.env.NEXT_PUBLIC_THEME;

type TokenKeys = keyof typeof camperContactTokens;
const getToken = (token: TokenKeys, fallbackCss?: string) => {
    switch (currentTheme) {
        case 'Campercontact':
            return camperContactTokens[token as keyof typeof camperContactTokens] || fallbackCss;
        case 'Zandvoort':
            return zandvoortTokens[token as keyof typeof zandvoortTokens] || fallbackCss;
        case 'Oberon':
            return whitelabelTokens[token as keyof typeof whitelabelTokens] || fallbackCss;
        default:
            return whitelabelTokens[token as keyof typeof whitelabelTokens] || fallbackCss;
    }
};

export const t = getToken;
export default getToken;
